import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TechnicalSupport = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        টেকনিক্যাল সাপোর্ট
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          এখানে টেকনিক্যাল সমস্যা এবং সাপোর্ট দেখানো হবে।
        </Typography>
      </Paper>
    </Box>
  );
};

export default TechnicalSupport; 